import { Grid, Typography } from '@mui/material';

import { RouterLink } from 'main/components/_common/RouterLink';

export const ExperienceDescription = () => {
    return (
        <Grid container direction="column">
            <Grid item>
                <Typography variant="body2" px={1}>
                    いつでも体験、見学 OK です
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2" px={1}>
                    ※練習時間、練習場所については、直前に変更になることがありますので、参加希望の方は、前日までに
                    <RouterLink path="/contact">お問い合わせ</RouterLink>
                    下さい
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="body2" px={1}>
                    ※体験、見学（初回）は、保護者の方が同行（送迎）できる日をお選びください
                </Typography>
            </Grid>
        </Grid >
    )
}
